/* The represented line under a value tile (DQ-12b): the figure kept out of the total, and its toggle. */
.line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 10px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed var(--line);
  color: var(--ink-muted);
  font-size: 0.7rem;
}

.line strong {
  color: var(--ink);
  font-family: var(--mono);
  font-weight: 600;
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 24px;
  cursor: pointer;
}

.toggle input {
  margin: 0;
}
